import React from 'react';
import PropTypes from 'prop-types';
import { Config, I18n } from '@deporvillage/utils-library-component';
import Picture from '@deporvillage/picture-component';

import styles from './Aplazame.module.scss';


const Type = {
    Product: 'product',
    Cart: 'cart',
};

const AplazameExtended = ({ config, price }) => {

    const loadRef = React.useRef(null);
    const [notLoaded, setNotLoaded] = React.useState(true);

    const moreInfo = notLoaded ? '+' : '-';

    const handleClick = (e) => {
        if (e.target === loadRef.current || loadRef.current.contains(e.target)) {
            e.preventDefault();
            setNotLoaded(!notLoaded);
        }
    };

    return (
        <div className={styles['aplazame-button-component']} data-testid='aplazame-button' onClick={handleClick}>
            <div className={styles['wrapper']} data-testid='aplazame-button-wrapper' ref={loadRef}>
                <Picture
                    src={`/static/aplazame/aplazame-icon.png`}
                    name={'Aplazame'}
                    width={16}
                    height={16}
                    lazy
                />{' '}
                <span><span><I18n>product_page.aplazame.title</I18n></span><span className={styles['inline']}><I18n>product_page.aplazame.sub_title</I18n></span></span> <span>{moreInfo} info</span>
            </div>
            {!notLoaded ?
                <Aplazame config={config} price={price} /> : null}
        </div>
    );
};

AplazameExtended.propTypes = {
    config: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        publicKey: PropTypes.string,
    }),
    price: PropTypes.number,
};

const Aplazame = ({ config, price, type }) => {
    const elem = React.useRef(null);
    const { publicKey, min, max } = config || {};
    const { country, currency, isMobile } = React.useContext(Config);

    const isActive = publicKey && price >= min && price <= max;

    React.useEffect(() => {
        if (!isActive) return;
        /* eslint-disable no-undef */
        let script = document.createElement('script');
        script.src = '//cdn.aplazame.com/aplazame.js';
        script.dataset.aplazame = publicKey;
        script.dataset.sandbox = false;
        script.async = true;
        script.setAttribute('fetchpriority', 'low');
        elem.current.appendChild(script);
        /* eslint-enable no-undef */
    }, []);

    return !isActive ? null : (
        <div
            className={`${styles['aplazame-component']} aplazame-widget`}
            ref={elem}
            data-aplazame-widget-instalments='v4'
            data-amount={price * 100}
            data-type={type || Type.Product}
            data-option-legal-advice='false'
            data-option-layout={`${isMobile ? 'vertical' : 'horizontal'}`}
            data-option-default-instalments='6'
            data-currency={currency}
            data-country={country.code}
            data-option-custom-styles="true"
        />
    );
};

Aplazame.propTypes = {
    config: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        publicKey: PropTypes.string,
    }),
    type: PropTypes.oneOf([Type.Product, Type.Cart]),
    price: PropTypes.number,
};

export default Aplazame;
export { AplazameExtended, Type as AplazameType };

